import { render, staticRenderFns } from "./WexameLayout.vue?vue&type=template&id=0652dff8&scoped=true&"
import script from "./WexameLayout.vue?vue&type=script&lang=js&"
export * from "./WexameLayout.vue?vue&type=script&lang=js&"
import style0 from "./WexameLayout.vue?vue&type=style&index=0&id=0652dff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652dff8",
  null
  
)

export default component.exports